import React from 'react';
import cn from 'classnames';
import Radio from '../../../../../../../components/common/radio';
import { Visibility, Option } from '../../../../../../../types/common-types';
import './style.scss';

interface ValueProps {
  id: string;
  value: string;
  error: boolean;
}

interface Props {
  id: string;
  title?: string;
  value?: string;
  error?: boolean;
  align?: string;
  required?: boolean;
  errorMsg?: string;
  helpMsg?: string;
  options: Option[];
  visibility?: Visibility;
  onSubmit: (id: string) => void;
  onChange: (value: ValueProps, callback?: () => void) => void;
  submitOnChange?: boolean;
}

const RadioBF: React.FC<Props> = ({
  id,
  title,
  value,
  visibility,
  required,
  errorMsg,
  helpMsg,
  error,
  align,
  options,
  submitOnChange = false,
  onChange,
  onSubmit,
}) => {
  const handleOnChange = (data: ValueProps) => {
    onChange(data, () => {
      if (submitOnChange) onSubmit(id);
    });
  };
  return (
    <Radio
      id={id}
      styleName={cn('radio')}
      visibility={visibility}
      value={value}
      align={align}
      options={options}
      label={title}
      error={error}
      required={required}
      onChange={handleOnChange}
      helperText={error ? errorMsg : helpMsg}
    />
  );
};
export default RadioBF;
